import { h } from 'preact';
import clsx from 'clsx';
import { useEffect, useState } from 'preact/hooks';
import IconPlay from '../utils/icon/play-dot.svg';
import IconPause from '../utils/icon/pause-dot.svg';
import { useGallery } from './product-gallery-context';

const ProductGalleryPagination = ({
  swiper,
  productMedia,
}) => {
  if (!swiper) return null;

  const [activeIndex, setActiveIndex] = useState(0);
  const {
    toggleVideo,
    playingVideoIds,
  } = useGallery();
  
  useEffect(() => {
    if (!swiper) return null;

    setActiveIndex(swiper.realIndex);

    const onSlideChange = () => setActiveIndex(swiper.realIndex);
    swiper.on('slideChange', onSlideChange);

    return () => {
      swiper.off('slideChange', onSlideChange);
    };
  }, [swiper]);
  
  const handleClick = (media, index, isActive) => {
    if (swiper && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(index);
    }
    if (media.mediaContentType === 'VIDEO' && isActive) {
      toggleVideo(media.id);
    }
  };

  return (
    <div className="flex gap-[17px]">
      {productMedia.map((media, index) => {
        const isVideo = media.mediaContentType === 'VIDEO';
        const isPlaying = playingVideoIds.has(media.id);
        const isActive = activeIndex === index;

        return (
          <button
            key={index}
            aria-label={`Go to slide ${index + 1}`}
            aria-current={isActive}
            onClick={() => handleClick(media, index, isActive)}
          >
            { isVideo
              ? isPlaying
                ? <IconPause className={clsx(!isActive && 'opacity-20')} />
                : <IconPlay className={clsx(!isActive && 'opacity-20')} />
              : <span className={clsx('bullet inline-block', isActive && 'bullet-active' )} />
            }
          </button>
        )
      })}
    </div>
  );
};

export default ProductGalleryPagination;